function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPlay2 = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-16ba8704-d69a-48ac-9eca-4e7ac01a853d",
    viewBox: "0 0 15 15",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m7.5,14.92C3.41,14.92.08,11.59.08,7.5S3.41.08,7.5.08s7.42,3.33,7.42,7.42-3.33,7.42-7.42,7.42Zm0-13.92C3.92,1,1,3.92,1,7.5s2.91,6.5,6.5,6.5,6.5-2.91,6.5-6.5S11.08,1,7.5,1Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.03,4.61v5.74c0,.42.46.68.83.47l5-3.01c.36-.22.35-.74-.02-.94l-5-2.73c-.36-.2-.81.06-.81.48h0Z",
    style: {
      fill: "#333"
    }
  }));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPlay2, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/play_2.e01a0df0.svg";
export { ForwardRef as ReactComponent };